module.exports = __webpack_public_path__ + "img/common_top_logo.1fa46701.png";